import { ELECTRON_USER_AGENT_MARKER } from '@griply/types';

// The shell resolves the OS zone itself when Chromium's ICU cannot; shells older than that release have no getTimeZone.
export const getShellTimeZone = async (): Promise<string | undefined> => {
  if (!navigator.userAgent.includes(ELECTRON_USER_AGENT_MARKER)) {
    return undefined;
  }
  try {
    return (await window.electron?.getTimeZone?.()) ?? undefined;
  } catch {
    return undefined;
  }
};
